import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_CREDITS = "getPaginatedCredits";
export const ALL_CREDITS = "getAllCredits";
export const CREATE_CREDIT_FORM = "createCreditForm";
export const DELETE_CREDIT = "deleteCredit";
export const GET_CREDIT_DATA = "getCreditData";
export const CREATE_CREDIT = "createCredit";
export const UPDATE_CREDIT = "updateCredit";
export const RUN_CREDIT = "runCredit";


// mutation types

export const SET_PAGINATED_CREDITS = "setPaginatedCredits";
export const SET_ALL_CREDITS = "setAllCredits";
export const SET_CREDIT_DATA = "setCreditData";
export const SET_CREDIT_META = "setCreditMeta";
export const SET_CREDIT_ERROR = "setCreditError";
export const SET_CREDIT_LOADING = "setCreditLoading";
export const CLEAR_CREDIT_ERROR = "clearCreditError";
export const SET_IS_DISABLED_CREDIT = "setIsDisabledCredit";


const state = {
    credits: [],
    paginatedCredits: [],
    credit_data: {},
    meta_credit : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllCredits(state) {
        return state.paginatedCredits;
    },

    allCredits(state) {
        return state.credits;
    },

    getCreditData(state) {
        return state.credit_data;
    },

    meta_credit(state) {
        return state.meta_credit;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_CREDITS](context, payload) {
        context.commit(SET_IS_DISABLED_CREDIT, false);
        context.commit(SET_CREDIT_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/credits?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_CREDIT_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_CREDITS, data);
                context.commit(SET_CREDIT_META, data);
                context.commit(SET_CREDIT_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_CREDIT_LOADING, false);
            context.commit(SET_CREDIT_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_CREDITS]() {
        return new Promise(resolve => {
            ApiService.get('/creditsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_CREDIT_FORM](context) {
        context.commit(SET_CREDIT_LOADING, false);
        context.commit(SET_CREDIT_ERROR, false);
        context.commit(SET_IS_DISABLED_CREDIT, false);
    },

    [GET_CREDIT_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_CREDIT, true);
        context.commit(SET_CREDIT_LOADING, true);
        context.commit(CLEAR_CREDIT_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/credit/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_CREDIT_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_CREDIT_DATA, response.data);
                    context.commit(SET_CREDIT_LOADING, false);
                    context.commit(SET_IS_DISABLED_CREDIT, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_CREDIT_LOADING, false);
                context.commit(SET_CREDIT_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_CREDIT, true);
            });
        });
    },

    [CREATE_CREDIT](context, payload) {
        context.commit(SET_CREDIT_LOADING, false);
        context.commit(SET_IS_DISABLED_CREDIT, true);
        context.commit(CLEAR_CREDIT_ERROR);
        return ApiService.post("/credit/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_CREDIT_ERROR);
            }
            else{
                context.commit(SET_CREDIT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Borçlandırma işlemi başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_CREDIT_ERROR);
                context.commit(SET_IS_DISABLED_CREDIT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_CREDIT_LOADING, false);
            context.commit(SET_CREDIT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_CREDIT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_CREDIT](context, payload) {
        context.commit(SET_CREDIT_LOADING, true);
        context.commit(SET_IS_DISABLED_CREDIT, true);
        context.commit(CLEAR_CREDIT_ERROR);
        
        return ApiService.put(`/credit/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_CREDIT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı borçlandırma işlemi başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_CREDIT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_CREDIT_LOADING, false);
            context.commit(SET_CREDIT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_CREDIT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_CREDIT](context, payload) {
        context.commit(SET_CREDIT_LOADING, true);
        context.commit(CLEAR_CREDIT_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/credit/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_CREDIT_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı borçlandırma işlemi başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_CREDIT_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },


    [RUN_CREDIT](context, payload) {
        context.commit(SET_IS_DISABLED_CREDIT, true);
        context.commit(SET_CREDIT_LOADING, true);
        context.commit(CLEAR_CREDIT_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/credit/run/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    AlertService.makeToast(
                        "warning",
                        "Yetkisiz!",
                        "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                    );
                    context.commit(SET_CREDIT_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    if(response) 
                    { 
                        context.commit(SET_CREDIT_DATA, response.data);
                        AlertService.makeToast(
                            "success",
                            "İşlem Başarılı",
                            "Borçlandırma işlemi başarıyla çalıştırılmıştır. ID numarası: " + payload.id
                        );
                        context.commit(SET_CREDIT_LOADING, false);
                        context.commit(SET_IS_DISABLED_CREDIT, false);
                        resolve(response);
                    }
                    else {
                        context.commit(SET_CREDIT_DATA, response.data);
                        AlertService.makeToast(
                            "danger",
                            "İşlem Başarısız",
                            "Borçlandırma işlemi başarısız."
                        );
                        context.commit(SET_CREDIT_LOADING, false);
                        context.commit(SET_IS_DISABLED_CREDIT, false);
                        resolve(response);
                    }
                }
            })
            .catch(({ response }) => {
                context.commit(SET_CREDIT_LOADING, false);
                
                context.commit(SET_CREDIT_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_CREDIT, true);
            });
        });
    },

    
    
};

const mutations = {

    [SET_PAGINATED_CREDITS](state, paginatedCredits) {
        state.paginatedCredits = paginatedCredits.data;
    },

    [SET_ALL_CREDITS](state, credits) {
        state.credits = credits;
    },

    [SET_CREDIT_DATA](state, credits_data) {
        state.credits_data = credits_data;
        state.errors = [];
    },

    [SET_CREDIT_META](state, meta_credit) {
        state.meta_credit = meta_credit;
    },

    [SET_CREDIT_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_CREDIT_ERROR](state) {
        state.errors = [];
    },
    
    [SET_CREDIT_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_CREDIT](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
